import {
  Briefcase, Users, Heart, PenTool, Zap, Tag, Calendar, Clock, Sunrise, Sunset,
  Utensils, Dumbbell, Sparkles, BookOpen, Coffee, Plane, Music, Camera, Code,
  ShoppingCart, Gift, Home, Star, Flag, Bell, Moon, Sun, Palette, Target,
  GraduationCap, Gamepad2, Film, Phone, Mail, MapPin, Leaf, Trophy, Rocket,
} from "lucide-react";

export const ICON_MAP = {
  Briefcase, Users, Heart, PenTool, Zap, Tag, Calendar, Clock, Sunrise, Sunset,
  Utensils, Dumbbell, Sparkles, BookOpen, Coffee, Plane, Music, Camera, Code,
  ShoppingCart, Gift, Home, Star, Flag, Bell, Moon, Sun, Palette, Target,
  GraduationCap, Gamepad2, Film, Phone, Mail, MapPin, Leaf, Trophy, Rocket,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function Icon({ name, ...props }) {
  const C = ICON_MAP[name] || Tag;
  return <C {...props} />;
}
